// Shared product-card picker; no collection view or preference storage work.
(() => {
  'use strict';
  if (!document.querySelector('[data-feed-atc-sheet],[data-feed-direct-add]')) return;
  const toggle = document.querySelector('[data-or-feed-view-toggle]');
  const messages = toggle ? toggle.dataset : {};
  const i18n = {
    openOption: messages.feedMsgOpenOption || 'Open the product to choose an option.',
    adding: messages.feedMsgAdding || 'ADDING…',
    addedToCart: messages.feedMsgAddedToCart || 'ADDED TO CART ✓',
    added: messages.feedMsgAdded || 'ADDED ✓',
    couldNotAdd: messages.feedMsgCouldNotAdd || 'Could not add this option.'
  };

  function setAtcBusy(container, busy) {
    if (!container) return;
    container.classList.toggle('is-adding', busy);
    container.querySelectorAll('[data-feed-variant-choice],[data-feed-direct-add],[data-feed-option-choice],[data-feed-colourway-choice],[data-feed-picker-add]').forEach((button) => {
      if (busy) {
        button.dataset.wasDisabled = button.disabled ? 'true' : 'false';
        button.disabled = true;
      } else if (button.dataset.wasDisabled !== 'true') {
        button.disabled = false;
      }
      if (!busy) delete button.dataset.wasDisabled;
    });
  }

  function addFeedVariant(variantId, source, container, trigger) {
    const status = container && container.querySelector('[data-feed-atc-status]');
    if (!variantId || typeof window.ORAddVariantToCart !== 'function') {
      if (status) status.textContent = i18n.openOption;
      return;
    }

    setAtcBusy(container, true);
    if (status) status.textContent = i18n.adding;
    const originalText = trigger ? trigger.textContent : '';

    window.ORAddVariantToCart(variantId, 1, source || 'feed')
      .then(() => {
        if (status) status.textContent = i18n.addedToCart;
        if (trigger) trigger.textContent = i18n.added;
        window.setTimeout(() => {
          if (container && container.matches('details')) container.open = false;
          if (trigger && originalText) trigger.textContent = originalText;
          if (status) status.textContent = '';
          setAtcBusy(container, false);
        }, 850);
      })
      .catch((error) => {
        if (status) status.textContent = error && error.message ? error.message : i18n.couldNotAdd;
        setAtcBusy(container, false);
      });
  }

  function initialiseFeedPicker(sheet) {
    const form = sheet && sheet.querySelector('[data-feed-picker]');
    if (!form || form.dataset.feedPickerReady === '1') return;
    form.dataset.feedPickerReady = '1';

    const groups = Array.from(form.querySelectorAll('[data-feed-option-group]'));
    const buttons = Array.from(form.querySelectorAll('[data-feed-option-choice]'));
    const colourwayGroup = form.querySelector('[data-feed-colourway-group]');
    const colourwayButtons = Array.from(form.querySelectorAll('[data-feed-colourway-choice]'));
    const variantInput = form.querySelector('[data-feed-picker-variant]');
    const addButton = form.querySelector('[data-feed-picker-add]');
    const pickerLabels = {
      chooseSize: form.dataset.feedLabelChooseSize || 'CHOOSE SIZE',
      chooseColour: form.dataset.feedLabelChooseColour || 'CHOOSE COLOUR',
      chooseOption: form.dataset.feedLabelChooseOption || 'CHOOSE OPTION',
      add: form.dataset.feedLabelAdd || 'ADD TO CART',
      soldOut: form.dataset.feedLabelSoldOut || 'SOLD OUT'
    };
    const variants = Array.from(form.querySelectorAll('[data-feed-variant]')).map((node) => {
      let options = [];
      try { options = JSON.parse(node.dataset.feedVariantOptions || '[]'); } catch (error) {}
      return {
        id: node.dataset.feedVariantId || '',
        options,
        available: node.dataset.feedVariantAvailable === 'true',
        price: node.dataset.feedVariantPrice || '',
        colourway: node.dataset.feedVariantColourway || ''
      };
    });
    const selected = [];
    let selectedColourway = '';

    function syncCardColourChoice(value) {
      if (!value) return;
      const card = form.closest('[data-product-card]');
      if (!card) return;
      const choice = Array.from(card.querySelectorAll('[data-card-colour-choice]')).find((node) => {
        return String(node.dataset.cardColourChoice || '') === String(value);
      });
      if (!choice || choice.classList.contains('is-active')) return;
      choice.dataset.orSkipPickerSync = '1';
      choice.click();
      delete choice.dataset.orSkipPickerSync;
    }

    buttons.forEach((button) => {
      if (button.classList.contains('is-active')) {
        selected[Number(button.dataset.feedOptionChoice)] = button.dataset.feedOptionValue;
      }
    });
    colourwayButtons.forEach((button) => {
      if (button.classList.contains('is-active')) selectedColourway = button.dataset.feedColourwayChoice || '';
    });

    function selectedMatches(variant, ignoreIndex) {
      if (selectedColourway && variant.colourway && String(variant.colourway) !== String(selectedColourway)) return false;
      return groups.every((group) => {
        const index = Number(group.dataset.feedOptionGroup);
        if (index === ignoreIndex) return true;
        const value = selected[index];
        return !value || String(variant.options[index]) === String(value);
      });
    }

    function choiceAvailable(index, value) {
      return variants.some((variant) => variant.available && String(variant.options[index]) === String(value) && selectedMatches(variant, index));
    }

    function exactVariant() {
      if (colourwayGroup && !selectedColourway) return null;
      if (groups.some((group) => !selected[Number(group.dataset.feedOptionGroup)])) return null;
      return variants.find((variant) => {
        if (selectedColourway && variant.colourway && String(variant.colourway) !== String(selectedColourway)) return false;
        return groups.every((group) => {
          const index = Number(group.dataset.feedOptionGroup);
          return String(variant.options[index]) === String(selected[index]);
        });
      }) || null;
    }

    function clearImpossibleSelections(changedIndex) {
      groups.forEach((group) => {
        const index = Number(group.dataset.feedOptionGroup);
        if (index === changedIndex || !selected[index]) return;
        const possible = variants.some((variant) => variant.available && groups.every((candidate) => {
          const candidateIndex = Number(candidate.dataset.feedOptionGroup);
          if (candidateIndex === index || candidateIndex === changedIndex) return true;
          const value = selected[candidateIndex];
          return !value || String(variant.options[candidateIndex]) === String(value);
        }) && String(variant.options[changedIndex]) === String(selected[changedIndex]) && String(variant.options[index]) === String(selected[index]));
        if (!possible) selected[index] = '';
      });
    }

    function updatePicker() {
      buttons.forEach((button) => {
        const index = Number(button.dataset.feedOptionChoice);
        const value = button.dataset.feedOptionValue;
        const active = String(selected[index] || '') === String(value);
        const available = choiceAvailable(index, value);
        button.classList.toggle('is-active', active);
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !available;
      });

      groups.forEach((group) => {
        const index = Number(group.dataset.feedOptionGroup);
        const label = form.querySelector('[data-feed-selected-label="' + index + '"]');
        if (label) label.textContent = selected[index] || 'Select';
      });

      colourwayButtons.forEach((button) => {
        const value = button.dataset.feedColourwayChoice || '';
        const active = String(selectedColourway || '') === String(value);
        const available = variants.some((variant) => variant.available && String(variant.colourway || '') === String(value) && groups.every((group) => {
          const index = Number(group.dataset.feedOptionGroup);
          const selectedValue = selected[index];
          return !selectedValue || String(variant.options[index]) === String(selectedValue);
        }));
        button.classList.toggle('is-active', active);
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !available;
      });
      const colourwayLabel = form.querySelector('[data-feed-colourway-label]');
      if (colourwayLabel) colourwayLabel.textContent = selectedColourway || 'Select';

      const exact = exactVariant();
      form.dataset.feedSelectedVariantId = exact && exact.available ? exact.id : '';
      if (variantInput) variantInput.value = form.dataset.feedSelectedVariantId;

      if (!addButton) return;
      const sizeGroup = form.querySelector('.or-feed-picker__group--size');
      const colourGroup = form.querySelector('.or-feed-picker__group--colour');
      const sizeIndex = sizeGroup ? Number(sizeGroup.dataset.feedOptionGroup) : -1;
      const colourIndex = colourGroup ? Number(colourGroup.dataset.feedOptionGroup) : -1;

      if (sizeIndex >= 0 && !selected[sizeIndex]) {
        addButton.disabled = true;
        addButton.textContent = pickerLabels.chooseSize;
      } else if ((colourIndex >= 0 && !selected[colourIndex]) || (colourwayGroup && !selectedColourway)) {
        addButton.disabled = true;
        addButton.textContent = pickerLabels.chooseColour;
      } else if (groups.some((group) => !selected[Number(group.dataset.feedOptionGroup)])) {
        addButton.disabled = true;
        addButton.textContent = pickerLabels.chooseOption;
      } else if (!exact || !exact.available) {
        addButton.disabled = true;
        addButton.textContent = pickerLabels.soldOut;
      } else {
        addButton.disabled = false;
        addButton.textContent = exact.price ? pickerLabels.add + ' · ' + exact.price : pickerLabels.add;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.feedOptionChoice);
        selected[index] = button.dataset.feedOptionValue;
        clearImpossibleSelections(index);
        if (button.closest('.or-feed-picker__group--colour')) syncCardColourChoice(button.dataset.feedOptionValue);
        updatePicker();
      });
    });

    colourwayButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedColourway = button.dataset.feedColourwayChoice || '';
        syncCardColourChoice(selectedColourway);
        const sizeGroup = form.querySelector('.or-feed-picker__group--size');
        if (sizeGroup) {
          const sizeIndex = Number(sizeGroup.dataset.feedOptionGroup);
          if (selected[sizeIndex] && !variants.some((variant) => variant.available && String(variant.colourway || '') === String(selectedColourway) && String(variant.options[sizeIndex]) === String(selected[sizeIndex]))) {
            selected[sizeIndex] = '';
          }
        }
        updatePicker();
      });
    });

    form.addEventListener('submit', (event) => {
      const id = form.dataset.feedSelectedVariantId || (variantInput && variantInput.value);
      if (variantInput && id) variantInput.value = id;
      if (!id) {
        event.preventDefault();
        updatePicker();
        return;
      }
      if (typeof window.ORAddVariantToCart !== 'function') return;
      event.preventDefault();
      addFeedVariant(id, 'feed-picker', sheet, addButton);
    });

    updatePicker();
  }

  document.addEventListener('click', (event) => {
    const close = event.target.closest && event.target.closest('[data-feed-atc-close]');
    if (close) {
      const sheet = close.closest('[data-feed-atc-sheet]');
      if (sheet) sheet.open = false;
      return;
    }

    const direct = event.target.closest && event.target.closest('[data-feed-direct-add]');
    if (direct) {
      if (typeof window.ORAddVariantToCart !== 'function') return;
      event.preventDefault();
      addFeedVariant(direct.dataset.feedDirectAdd, 'feed-direct', direct.closest('[data-feed-card]') || direct.parentElement, direct);
    }
  });

  document.addEventListener('toggle', (event) => {
    const sheet = event.target;
    if (!sheet || !sheet.matches || !sheet.matches('[data-feed-atc-sheet]')) return;

    if (sheet.open) {
      sheet._orPreviousFocus = document.activeElement;
      document.querySelectorAll('[data-feed-atc-sheet][open]').forEach((other) => {
        if (other !== sheet) other.open = false;
      });
      document.documentElement.classList.add('or-feed-sheet-open');
      initialiseFeedPicker(sheet);
      window.requestAnimationFrame(() => {
        const firstOption = sheet.querySelector('[data-feed-colourway-choice].is-active:not([disabled]),[data-feed-option-choice].is-active:not([disabled]),[data-feed-colourway-choice]:not([disabled]),[data-feed-option-choice]:not([disabled])');
        const closeButton = sheet.querySelector('[data-feed-atc-close]');
        (firstOption || closeButton)?.focus();
      });
      return;
    }

    if (!document.querySelector('[data-feed-atc-sheet][open]')) {
      document.documentElement.classList.remove('or-feed-sheet-open');
    }
    const previous = sheet._orPreviousFocus;
    if (previous && document.contains(previous) && typeof previous.focus === 'function') {
      window.requestAnimationFrame(() => previous.focus({ preventScroll: true }));
    }
    sheet._orPreviousFocus = null;
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const sheet = document.querySelector('[data-feed-atc-sheet][open]');
    if (sheet) {
      event.preventDefault();
      sheet.open = false;
      sheet.querySelector('summary')?.focus();
    }
  });

})();
